import { type Schema } from 'yup';
import {
  type ILiveValuesTransform,
  type ILiveValuesTransformResult,
  type LiveValuesTransform,
} from './LiveTypes.ts';
import { LIVE_VALUES_TRANSFORM_KEY } from './live.ts';

/**
 * Invoca la `LiveValuesTransform` (se registrata).
 * No-op coerente se assente: ritorna `{ values, changedPaths: [] }`.
 */
export function applyLiveValuesTransform(
  schema: Schema,
  input: Omit<ILiveValuesTransform, 'schema'>,
): ILiveValuesTransformResult {
  const transform = schema.meta()?.[LIVE_VALUES_TRANSFORM_KEY] as
    | LiveValuesTransform
    | undefined;
  if (!transform) return { values: input.values, changedPaths: [] };
  return transform({ ...input, schema });
}
